import axios from 'axios';
import { REQUEST_URL } from '../config/urls';

const enviar = () => {
  return {
    type: 'ENVIAR_EMAIL',
  };
};

const enviado = (response) => {
  if (response.response === undefined || response.response === null) {
    return {
      type: 'FALTOU_PREENCHER_CAMPOS_EMAIL',
    };
  } else if (response.response.includes('OK')) {
    return {
      type: 'ENVIADO_EMAIL',
    };
  } else if (
    response.response.includes('Username and Password not accepted.')
  ) {
    return {
      type: 'SEM_PERMISSAO_EMAIL',
    };
  }
};

const erro = (erro) => {
  if (erro.response.data.error.statusCode === 401) {
    axios.defaults.headers.common['Authorization'] = '';
    return {
      type: 'LOGOUT',
    };
  }
  return {
    type: 'ERRO_EMAIL',
    erro,
  };
};

export const enviarEmail = (email) => {
  return (dispatch) => {
    dispatch(enviar());
    return axios
      .post(`${REQUEST_URL}/email`, email)
      .then((response) => {
        dispatch(enviado(response.data));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/EmailActions.js